import { ShowyedaLogo } from 'app/components/ShowyedaLogo';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import dashboardImg from './assets/img/icon/dash.png';
import sifImg from './assets/img/icon/awesome-trophy.png';
import { ProfileDropdown } from './components/PopupLogout';
import Cookies from 'js-cookie';
import PasswordResetEmail from 'app/components/PasswordResetEmail';

type Props = {};

const RiderLandingPage = (props: Props) => {
  const [popupVisible, setPopupVisible] = React.useState<boolean>(false);
  const [passwordChangePage, setPasswordChangePage] = useState<number>(1);
  const currentName = Cookies.get('userName');
  const [getFirstLetter, setGetFirstLetter] = useState<string>();
  const getName = () => {
    if (currentName) {
      const firstLetter = currentName.charAt(0);
      setGetFirstLetter(firstLetter);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleDashboard = () => {
    navigate('/rider-landing-page/dashboard');
  };
  const handleSif = () => {
    navigate('/rider-landing-page/sif');
  };
  const handleShowPoints = () => {
    navigate('/rider-landing-page/show-points');
  };
  const handleChangePassword = e => {
    setPopupVisible(true);
    setPasswordChangePage(3);
  };
  useEffect(() => {
    getName();
  }, []);
  const [showProfileDropDown, setShowProfileDropDown] = React.useState(false);
  const handleClick = () => {
    setShowProfileDropDown(!showProfileDropDown);
  };
  const menuRef = React.useRef(null);
  const imgRef = React.useRef(null);
  window.addEventListener('click', e => {
    if (e.target !== menuRef.current && e.target !== imgRef.current) {
      setShowProfileDropDown(false);
    }
  });

  const isDashboard = location?.pathname === '/rider-landing-page/dashboard';
  const isSif = location?.pathname?.includes('sif');
  const isShowPoints = location?.pathname?.includes('show-points');
  const isDarkSidebar = isDashboard || isShowPoints;

  return (
    <MainWrapper>
      <NavWrapper $light={!isDarkSidebar}>
        <NavItem
          onClick={handleDashboard}
          className={`${isDashboard ? 'active' : ''} ${
            !isDarkSidebar ? 'on-light' : ''
          }`}
          title="Dashboard"
        >
          <img src={dashboardImg} alt="Dashboard" />
        </NavItem>
        <NavItem
          onClick={handleSif}
          className={`${isSif ? 'active' : ''} ${
            !isDarkSidebar ? 'on-light' : ''
          }`}
          title="SIF"
        >
          <img src={sifImg} alt="SIF" />
        </NavItem>
        <NavItem
          onClick={handleShowPoints}
          className={`${isShowPoints ? 'active' : ''}`}
          title="Shows & Points"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M3 9h18" />
            <path d="M9 21V9" />
          </svg>
        </NavItem>
      </NavWrapper>
      <HeaderContentWrapper $light={!isDarkSidebar}>
        <HeaderWrapper $transparent={isDarkSidebar}>
          <div className="header">
            <ShowyedaLogo className="logo" />
            <div className="logout-btn">
              <button onClick={handleClick} ref={imgRef}>
                {getFirstLetter}
              </button>
            </div>
          </div>
          {showProfileDropDown && (
            <ProfileDropdown
              setShowProfileDropDown={setShowProfileDropDown}
              menuRef={menuRef}
              onChangePassword={handleChangePassword}
            />
          )}
        </HeaderWrapper>
        <Outlet />
      </HeaderContentWrapper>
      <PasswordResetEmail
        show={popupVisible}
        setShow={setPopupVisible}
        setPage={setPasswordChangePage}
        page={passwordChangePage}
      />
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  background-color: #ffffff;
  display: flex;
  width: 100%;
  height: 100vh;
  position: relative;
  padding-left: 50px;
  z-index: 2;
`;

const NavWrapper = styled.div<{ $light?: boolean }>`
  height: 100vh;
  background: ${({ $light }) =>
    $light
      ? 'linear-gradient(144deg, rgb(239,246,255) 0%, rgb(255,255,255) 50%, rgb(238,242,255) 100%)'
      : '#171717'};
  border-right: ${({ $light }) =>
    $light ? '1px solid rgba(0,0,0,0.08)' : 'none'};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  padding: 170px 8px 117px;
  z-index: 10;
  width: 50px;
  gap: 24px;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50px;
  cursor: pointer;
  transition: filter 0.2s, background 0.2s;

  /* dark sidebar (dashboard / show-points) */
  filter: brightness(0) invert(0.5);
  color: rgba(255, 255, 255, 0.5);

  img {
    width: 20px;
    height: 20px;
    display: block;
  }

  svg {
    width: 18px;
    height: 18px;
    display: block;
  }

  /* light sidebar (sif / enrollment) */
  &.on-light {
    filter: none;
    opacity: 0.45;
    color: #000000;
    img {
      filter: brightness(0);
    }
  }

  &.active {
    background: #0244fa;
    filter: none !important;
    opacity: 1;
    color: #ffffff;
    img {
      filter: brightness(0) invert(1);
    }
  }

  &:hover:not(.active) {
    opacity: 0.75;
  }
`;

const HeaderContentWrapper = styled.div<{ $light?: boolean }>`
  overflow: auto;
  height: 100%;
  width: 100%;
  position: relative;
  background: ${({ $light }) =>
    $light
      ? 'linear-gradient(144deg, rgb(239,246,255) 0%, rgb(255,255,255) 50%, rgb(238,242,255) 100%)'
      : 'transparent'};
  ::-webkit-scrollbar {
    width: 1px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;

const HeaderWrapper = styled.div<{ $transparent?: boolean }>`
  position: ${({ $transparent }) => ($transparent ? 'absolute' : 'relative')};
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  display: flex;
  justify-content: space-between;

  .header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: transparent;
    height: 86px;
    width: 100%;
    border-bottom: none;
  }

  .logo {
    position: absolute;
    top: 12px;
    left: 20px;
    padding: 0px !important;
    img {
      width: auto;
    }
  }

  .logout-btn {
    display: flex;
    justify-content: flex-end;
    padding: 17px 20px;
    button {
      cursor: pointer;
      font-size: 18px;
      font-weight: 600;
      width: 51px;
      height: 51px;
      border-radius: 50%;
      border: none;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      background: #ffffff;
      color: #171717;
    }
  }
`;

export default RiderLandingPage;
